var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGreenArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z",
    fill: "#00CC66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7567 10.831C14.1262 10.4205 14.7585 10.3872 15.169 10.7567L20.169 15.2567C20.3797 15.4463 20.5 15.7165 20.5 16C20.5 16.2835 20.3797 16.5536 20.169 16.7433L15.169 21.2433C14.7585 21.6127 14.1262 21.5795 13.7567 21.169C13.3873 20.7584 13.4205 20.1262 13.831 19.7567L18.0052 16L13.831 12.2433C13.4205 11.8738 13.3873 11.2415 13.7567 10.831Z",
    fill: "#00CC66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenArrow1);
export default __webpack_public_path__ + "static/media/icon_green_arrow1.f7823ba37117d49e655b89e72a1ceb41.svg";
export { ForwardRef as ReactComponent };